export const PageDataState = {
    Searchs: {
        training_details_eb_02_id: {
            type: 'text',
            id: 'training_details_eb_02_id',
            label: '',
            value: '',
        },
        enterprise_name: {
            type: 'text',
            id: 'enterprise_name',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        training_details_eb_02_id: {
            type: 'select',
            id: 'training_details_eb_02_id',
            label: 'รุ่นที่',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },   
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },                                             
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        }      
    },
    InputGroup: {}
}